<div class="info_container" *ngIf="isVisible" [@infoAnimation]>
  <div
    class="info_content"
    (click)="close()"
    #info
    [ngStyle]="{ top: posTop + 'px', left: posLeft + 'px' }"
  >
    <mat-icon
      class="notranslate"
      *ngIf="data"
      [ngClass]="{ bottom: getDirection() === 'down' }"
    >
      arrow_drop_{{ getDirection() }}
    </mat-icon>
    <p *ngIf="data">{{ data.text }}</p>
  </div>
</div>
